<template>
  <div class="modal-pipe-holder">
    <PipeEdit/>
  </div>
</template>

<script>
import PipeEdit from '@/components/pipe/PipeEdit';

export default {
  components: { PipeEdit }
};
</script>

<style scoped>
.modal-pipe-holder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>